<script lang="ts">
  import { EventHandler } from '../../utilities/EventHandler';
  import { getDataAttribute } from '../../utilities/DataTableUtilities';

  export let e2eAttributeSuffix: string | undefined;
  export let dataTableId: string | undefined;
  export let loading: boolean;

  let eventHandler = new EventHandler();

  function emitEvent(name: string, detail?: CustomEvent['detail']) {
    eventHandler.dispatch(name, detail || {});
  }
</script>

<div class="mc-datatable__topbar-edition">
  <button
    type="button"
    class="mc-button mc-button--s mc-button--square mc-button--bordered-neutral {loading
      ? 'is-disabled'
      : ''}"
    {...getDataAttribute(e2eAttributeSuffix, `${dataTableId}EditButton`)}
    on:click={() => emitEvent('click-edit')}
  >
    <span class="mc-button__icon">
      <navigation-publish-edit-24px size="24px" />
    </span>
  </button>
  <button
    type="button"
    class="mc-button mc-button--s mc-button--square mc-button--bordered-neutral {loading
      ? 'is-disabled'
      : ''}"
    {...getDataAttribute(e2eAttributeSuffix, `${dataTableId}DownloadButton`)}
    on:click={() => emitEvent('click-download')}
  >
    <span class="mc-button__icon"><media-download-web-24px size="24px" /></span>
  </button>
</div>

<!-- svelte-ignore css-unused-selector -->
<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/all-settings';

  @import '@mozaic-ds/styles/generic/g.reset.scss';
  @import '@mozaic-ds/styles/components/c.badge';
  @import '@mozaic-ds/styles/components/c.button';
  @import '@mozaic-ds/styles/components/c.text-input';
  @import '@mozaic-ds/styles/components/c.left-icon-input';
  @import '@mozaic-ds/styles/components/c.links';
  @import '@mozaic-ds/styles/components/c.tag';
  @import '@mozaic-ds/styles/components/c.toggle';
  @import '@mozaic-ds/styles/components/c.datatable-tools';
  @import '@mozaic-ds/styles/components/c.datatable-header';
</style>
